<template>
    <div style="display:inline;">{{myValue|currency('')}} {{currencySymbol}}</div>
</template>

<script>
    export default {
        name: "MoneyFormat",
        props: {
            value: Number,
            show_currency: {
                type: Boolean,
                default: true
            },
            currency_symbol: {
                type: String,
                default: '€'
            }

        },
        computed: {
            myValue: function() {
                return (this.value/100).toFixed(2)
            },
            currencySymbol: function() {
                if (this.show_currency) {
                    return this.currency_symbol
                } else {
                    return ''
                }
            }
        }
    }
</script>
